


















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends Vue {
  private data: any = {
    下载说明:
      "学生如果需要登录平台，须下载指定的安装包才能登录使用。点击复制下载地址按钮，即可另起网页打开系统安装包，教师可将网页地址复制后通过微信等工具下发给班里的学生下载安装，安装完成后，学生通过教师指定的账户登录。如果发现无权限下载，表示贵机构没有购买该系统。",
    创建学生账户:
      "添加班级，创建该班级下的学生，并将学生安装包地址及账户分配给每个学生。",
    教学资料准备: "上传课程相关的病例、题库、图片、视频、课件。",
    关联教材知识点:
      "将资源和教材的知识点进行关联，以便学生更好的学习和查找资料。",
    "课堂教学、练习互动":
      "基于教材及其关联知识点进行课堂授课，同时安排学生进行课堂练习，支持教师机对学生机控屏。",
    组织安排在线考试: "考试模块新建考试，安排学生在线考试",
    布置课后作业:
      "教师可布置课后练习，要求学生在限定的时间范围内进行舌面诊实训练习或临床思维实训练习。",
    学习情况统计:
      "教师可在统计模块查看学生的学习情况，包括学习时长、考试成绩、练习量等。",
    互动答疑: "教师对学生的提问进行答疑",
  };
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private ifShow(type: any) {
    let result: any = false;
    const index = this.user["产品权限"].findIndex((val: any) => {
      return val === type;
    });
    if (index != -1) {
      result = true;
    }
    return result;
  }
  private handelCopyLink(val: any) {
    // 创建一个临时的textarea元素
    const textarea = document.createElement("textarea");
    textarea.value = this.systemInfo.SETTING.exe[val];
    // 将textarea添加到body中
    document.body.appendChild(textarea);
    // 选中textarea中的文本
    textarea.select();

    // 使用document.execCommand('copy')来复制文本
    // 注意：这个方法在现代浏览器中可能因安全策略而受限
    try {
      (document as any).execCommand("copy");
      this.$message.success("复制成功"); // 假设你有一个显示消息的方法
    } catch (err) {
      this.$message.error("复制失败"); // 假设你有一个显示错误的方法
    }

    // 移除临时的textarea元素
    document.body.removeChild(textarea);
  }
  mounted() {}
}
